import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as clientAction from "../../../redux/actions/clientAction";
import { useDebounce } from "../../../utils/useDebounceSearch";
import SearchAutoComplete from "../../../library/custom/searchAutoComplete/SearchAutoComplete";
import FormLabels from "../../../library/custom/formLabel/FormLabels";
import "../reportDashboard.scss";

// Same shared client-search pattern as the stormwater Inspection Record page
// (feature/storm-water/inspection/components/reportList.jsx's "HBView" client box):
// reuses the app-wide searchAllClientsReducerData store + clientAction.searchAllClients
// (GET /v1/getorganisationlist) rather than a feature-local fetch, so this stays
// consistent with every other client picker in the app and needs no new service code.
const DashboardClientFilter = ({ value, onChange }) => {
  const dispatch = useDispatch();
  const allClients = useSelector((state) => state.searchAllClientsReducerData);
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 500);

  useEffect(() => {
    dispatch(clientAction.searchAllClients(debouncedSearch));
  }, [debouncedSearch, dispatch]);

  return (
    <div className="rdClientFilter" data-testid="dashboard-client-filter">
      <FormLabels label="Client" isRequired={false} />
      <SearchAutoComplete
        name="dashboardClientFilter"
        testId="dashboardClientFilter"
        optionsData={allClients?.data ?? []}
        isKeyValuePair
        isLoading={allClients?.isLoading}
        typeOnchange={(event, newInputValue) => setSearchText(newInputValue || "")}
        value={value}
        onChange={(event, newValue) => onChange(newValue || null)}
        placeholderText="Search for a client..."
        noOptionsTextMsg="No Client"
      />
    </div>
  );
};

export default DashboardClientFilter;
